<template>
  <div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      v-if="templateSelectorDialog.visible"
      :visible.sync="templateSelectorDialog.visible"
      :template-uuids="templateSelectorDialog.templateUuids"
      :document-type-uuid="templateSelectorDialog.documentTypeUuid"
      :lob="templateSelectorDialog.lob"
      :job="templateSelectorDialog.job"
      :data="templateSelectorDialog.data"
      :job-uuid-list="templateSelectorDialog.jobUuidList"
      :call-by-instruction="true"
      @instructionCallback="instructionCallback"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateInstructionRecord } from '@/api/sysManage/baseConfig/instruction'
import { lockHbl } from '@/api/booking/job'

export default {
  name: 'PrintFileWindow',
  components: { cargoTemplateSelectorDialog },
  data() {
    return {
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      },
      selectFileType: '',
      documentTypeUuid: '',
      templateUuids: [],
      bachDocumentTypeUuid: '',
      batchTemplateUuid: '',
      lockedHblTab: false,
      jobKeys: [],
      templateSelectorDialog: {
        visible: false,
        data: {}
      }
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, job) {
      this.isSop = false
      this.tenantInstruction.uuid = uiInstruction.tenantInstructionUuid
      this.tenantInstruction.platformInstructionCode = uiInstruction.platformInstructionRuleCode
      this.tenantInstruction.allowMultipleOperations = uiInstruction.allowMultipleOperations || false
      if (uiInstruction.instructionRuleJson) {
        this.selectFileType = uiInstruction.instructionRuleJson.selectFileType || ''
        this.documentTypeUuid = uiInstruction.instructionRuleJson.documentTypeUuid || ''
        this.templateUuids = uiInstruction.instructionRuleJson.templateUuids || []
        this.bachDocumentTypeUuid = uiInstruction.instructionRuleJson.bachDocumentTypeUuid || ''
        this.batchTemplateUuid = uiInstruction.instructionRuleJson.batchTemplateUuid || ''
      } else {
        this.selectFileType = ''
        this.documentTypeUuid = ''
        this.templateUuids = []
        this.bachDocumentTypeUuid = ''
        this.batchTemplateUuid = ''
      }
      if (uiInstruction.instructionParamJson) {
        this.lockedHblTab = uiInstruction.instructionParamJson.lockedHblTab === '1'
      } else {
        this.lockedHblTab = false
      }
      this.jobKeys = [job.uuid]
      this.showTemplateSelectorDialog([job], SystemConstants.INSTRUCTION_ACTION_SINGLE.code)
    },
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs, action) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionRuleJson) {
        this.selectFileType = sopInstruction.instructionRuleJson.selectFileType || ''
        this.documentTypeUuid = sopInstruction.instructionRuleJson.documentTypeUuid || ''
        this.templateUuids = sopInstruction.instructionRuleJson.templateUuids || []
        this.bachDocumentTypeUuid = sopInstruction.instructionRuleJson.bachDocumentTypeUuid || ''
        this.batchTemplateUuid = sopInstruction.instructionRuleJson.batchTemplateUuid || ''
      } else {
        this.selectFileType = ''
        this.documentTypeUuid = ''
        this.documentTypeUuid = []
        this.bachDocumentTypeUuid = ''
        this.batchTemplateUuid = ''
      }
      if (sopInstruction.instructionParamJson) {
        this.lockedHblTab = sopInstruction.instructionParamJson.lockedHblTab === '1'
      } else {
        this.lockedHblTab = false
      }
      this.jobKeys = jobs.map(job => job.uuid)
      this.showTemplateSelectorDialog(jobs, action)
    },
    showTemplateSelectorDialog(jobs, action) {
      this.templateSelectorDialog = {
        visible: false,
        data: {}
      }
      this.templateSelectorDialog.lob = jobs[0].lob
      if (SystemConstants.INSTRUCTION_ACTION_SINGLE.code === action) {
        const job = jobs[0]
        if (JobUtils.isBlockJob(job)) {
          this.$message.warning(job.jobNo + this.$t('SeaExport.LockedPleaseContactSupervisorUnlock'))
          return
        }
        // 单个打印
        if (this.selectFileType) {
          // 通过文件类型获取打印模板
          this.templateSelectorDialog.documentTypeUuid = this.documentTypeUuid
        } else {
          this.templateSelectorDialog.templateUuids = this.templateUuids
        }
        let jobData
        if (job.lob === SystemConstants.SE.code) {
          jobData = new SeaExportJob(job)
          jobData.loadJobRelated({
            job: true,
            manifestInfos: true,
            seaCargoDoc: true
          })
        } else if (job.lob === SystemConstants.SI.code) {
          jobData = new SeaImportJob(job)
          jobData.loadJobRelated({
            job: true,
            seaCargoDoc: true
          })
        } else if (job.lob === SystemConstants.AE.code) {
          jobData = new AirExportJob(job)
          jobData.loadJobRelated({
            job: true,
            airCargoDoc: true
          })
        } else if (job.lob === SystemConstants.AI.code) {
          jobData = new AirImportJob(job)
          jobData.loadJobRelated({
            job: true,
            airCargoDoc: true
          })
        } else if (job.lob === SystemConstants.RE.code || job.lob === SystemConstants.RI.code) {
          jobData = new RailwayExportJob(job)
          jobData.loadJobRelated({
            job: true
          })
        } else if (job.lob === SystemConstants.IE.code) {
          jobData = new IntegratedJob(job)
          jobData.loadJobRelated({
            job: true
          })
        }
        this.templateSelectorDialog.job = jobData
        if (JobUtils.isBlockJob(this.templateSelectorDialog.job)) {
          this.$message.info(this.templateSelectorDialog.job.jobNo + this.$t('SeaExport.LockedPleaseContactSupervisorUnlock'))
          return
        }
        this.templateSelectorDialog.visible = true
      } else {
        // 批量打印
        this.templateSelectorDialog.jobUuidList = Array.from(jobs, p => p.uuid)
        if (this.selectFileType) {
          // 通过文件类型获取打印模板
          this.templateSelectorDialog.documentTypeUuid = this.bachDocumentTypeUuid
        } else {
          // 通过模板uuids获取打印模板
          this.templateSelectorDialog.templateUuids = [this.batchTemplateUuid]
        }
        this.templateSelectorDialog.visible = true
      }
    },
    instructionCallback(data) {
      data.instructionUuid = this.tenantInstruction.uuid
      const ajaxResults = []
      ajaxResults.push(generateInstructionRecord(data))
      if (this.lockedHblTab) {
        ajaxResults.push(lockHbl({ jobKeys: this.jobKeys.join(',') }).then(res => {
          this.$emit('lockHbl')
        }))
      }
      const loading = getLoading4Cxt(this)
      Promise.all(ajaxResults).then(res => {
        this.$emit('instructionCallback')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>
